import { getAxiosClient } from 'src/utils/axios';

export const getKvImageList = () => async (dispatch) => {
  const cli = getAxiosClient('kvImageList');

  dispatch({ type: 'AJAX/LOADING/kvImageList' });

  try {
    const res = await cli.get('/active-kvs');
    dispatch({ type: 'AJAX/SUCCESS/kvImageList', data: res.data });
    return res.data;
  } catch (e) {
    dispatch({ type: 'AJAX/FAILED/kvImageList', data: null });
    console.error(e);
  }
};
